import { type ReactNode } from 'react';

import {
  type BettingInsightsContent,
  type BettingInsightsResult,
  type EsIndex,
} from '~/apps/product-plus/configuration/types';

import styles from './styles/EventDetails.module.css';

const EventDetails = <TIndex extends EsIndex>({
  content,
  renderTitle,
  result,
}: {
  content: BettingInsightsContent<TIndex>[];
  renderTitle: ({
    content,
    result,
  }: {
    content: BettingInsightsContent<TIndex>[];
    result: BettingInsightsResult<TIndex>;
  }) => ReactNode;
  result: BettingInsightsResult<TIndex>;
}) => {
  return (
    <p className={styles.eventDetails}>
      <span data-testid="event-details">{renderTitle({ content, result })}</span>
    </p>
  );
};

export { EventDetails };
